import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Unsubscriber, ContactList } from '../unsubscriber/unsubscriber.model';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'unsubscriber-edit',
  templateUrl: './unsubscriber-edit.component.html',
  styleUrls: ['./unsubscriber-edit.component.css']
})

export class UnsubscriberEditComponent implements OnInit, OnDestroy {
  private modal: any;
  private unsubscriber: Unsubscriber = new Unsubscriber();
  private selectedContactLists: ContactList[] = [];
  private subs = new SubSink();

  @Output() private saved: EventEmitter<Resubscriber> = new EventEmitter<Resubscriber>();

  constructor(private repository: HttpRepositoryService, private antiForgery: AntiForgeryTokenService) { }

  ngOnInit() {
    this.modal = $('#unsubscriberForm');
  }

  public show(data: Unsubscriber) {
    this.unsubscriber = data;

    this.modal.modal({
      show: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  private save() {
    let resubscriber = new Resubscriber();
    resubscriber.id = this.unsubscriber.id;
    resubscriber.selectedContactList = this.selectedContactLists;

    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Resubscribe user', 'error');
      } else {
        this.subs.sink = this.repository.post<Resubscriber>('api/Admin/Resubscribe', resubscriber, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Resubscribe user', 'error');
          } else {
            Toast.Show('User resubscribed successfully.', 'Resubscribe user', 'success');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private onChanged(event: any) {
    if (event.target.checked) {
      let selected = this.unsubscriber.contactLists.find(x => x.id == parseInt(event.target.id));

      if (selected) {
        this.selectedContactLists.push(new ContactList(selected.id, selected.name));
      }
    } else {
      let selected = this.selectedContactLists.find(x => x.id == event.target.id);

      if (selected) {
        let index = this.selectedContactLists.indexOf(selected);
        this.selectedContactLists.splice(index, 1);
      }
    }
  }

  private onSaveCompleted(data: Resubscriber) {
    this.close();
    this.saved.emit(data);
  }

  private close() {
    this.modal.modal('hide');
    this.unsubscriber = new Unsubscriber();
    this.selectedContactLists = [];
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

export class Resubscriber {
  id: number;
  selectedContactList: ContactList[];
}
